import { connect } from 'react-redux'
import { pageToggleLeft } from 'redux/actions'
import SearchFilters from 'pages/currentawareness/SearchFilters'

const mapDispatchToProps = dispatch => ({
  pageToggleLeft: force => dispatch(pageToggleLeft(force))
})

export default connect(null, mapDispatchToProps)(SearchFilters)
